import { SearchIcon, XIcon } from "assests/GmsIcons";
import React, { useContext, useEffect, useState } from "react";
import { SB3RuleContext } from "../Rules/SB3RuleContext";
import SidePanelElement from "./SidePanelElement";
import MathPanel from "./MathPanelComponent";
import { TSidePanelData } from "./dataTypes";

type Choice = {
    name: string;
}

type Field = {
    type: string;
    name: string;
    id: string;
    choices: Choice[];
}

type Item = {
    type: string;
    name: string;
    id: string;
    fields?: Field[];
    categories?: Item[];
}

const SidePanelComponent = () => {
    const { openPickPanel, modelData, sidePaneldata, updateSidePanelData, sidepanelType, updateFilteredData, filteredData, hidePickPanel, selectedObj } = useContext(SB3RuleContext);

    const [searchChoice, setSearchChoice] = useState<boolean>(false)
    useEffect(() => {
        const parseData = () => {
            const dataList: any[] = [];
            modelData?.dataModels?.map((dataModel: any) => {
                const obj: {
                    type: string;
                    name: string;
                    id: string;
                    fields: [];
                    categories: [];
                } = { type: "", name: "", id: "", fields: [], categories: [] };
                obj.name = dataModel?.data?.name;
                obj.id = dataModel?.id;
                obj.type = dataModel?.type?.toLowerCase();
                obj.fields = dataModel?.data?.fields?.map((field: any) => {
                    const fieldObj: {
                        type: string;
                        name: string;
                        id: string;
                        choices?: [];
                        submodel?: string;
                        submodelName?: string;
                    } = {
                        type: "",
                        name: "",
                        id: "",
                        submodel: "",
                        submodelName: ""
                    };

                    fieldObj.type = field?.type?.toLowerCase();
                    fieldObj.id = field?.id;
                    fieldObj.name = field?.name;
                    fieldObj.submodel = dataModel?.id
                    fieldObj.submodelName = dataModel?.data?.name
                    if (field?.type === "Multi-choice") {
                        fieldObj.choices = field?.dataConfiguration?.choices?.map((choice: any) => {
                            return {
                                type: "choice",
                                name: choice?.av_value,
                                displayValue: choice?.display_value,
                                id: choice?.av_id,
                                field: fieldObj?.id,
                                fieldName: fieldObj?.name,
                                submodel: dataModel?.id,
                                submodelName: dataModel?.data?.name

                            }
                        })
                    }
                    return fieldObj
                });
                obj.categories = dataModel?.data?.productCategories?.map(
                    (category: any) => {
                        const fieldObj: {
                            type: string;
                            name: string;
                            id: string;
                            categories: [];
                            submodel?: string;
                            submodelName?: string;

                        } = {
                            name: "",
                            id: "",
                            type: "",
                            categories: [],
                            submodel: ""
                        };
                        fieldObj.type = category?.type?.toLowerCase();
                        fieldObj.id = category?.id;
                        fieldObj.name = category?.data?.name;
                        fieldObj.submodel = dataModel?.id
                        fieldObj.submodelName = dataModel?.data?.name
                        fieldObj.categories = category?.data?.categories?.data?.map(
                            (cat: any) => {
                                return {
                                    type: "product",
                                    name: cat?.name,
                                    id: cat?.id,
                                    category: category?.id,
                                    submodel: dataModel?.id,
                                    categoryName: fieldObj?.name,
                                    submodelName: dataModel?.data?.name
                                };
                            }
                        );
                        return fieldObj
                    }
                );

                dataList.push(obj);
                return dataList;
            });

            modelData?.fields?.map((field: any) => {
                const fieldObj: {
                    type: string;
                    name: string;
                    id: string;
                    choices?: [];
                } = {
                    type: "",
                    name: "",
                    id: "",
                };
                fieldObj.type = field?.type?.toLowerCase();
                fieldObj.id = field?.id;
                fieldObj.name = field?.data?.name;
                if (field?.type === "Multi-choice") {
                    fieldObj.choices = field?.dataConfiguration?.choices?.map((choice: any) => {
                        return {
                            type: "choice",
                            name: choice?.av_value,
                            displayValue: choice?.display_value,
                            id: choice?.av_id,
                            field: fieldObj?.id,
                            fieldName: fieldObj?.name
                        }
                    })
                }
                dataList?.push(fieldObj);
                return dataList;
            });

            modelData?.productCategories?.map((category: any) => {
                const fieldObj: {
                    type: string;
                    name: string;
                    id: string;
                    categories: [];
                } = {
                    name: "",
                    id: "",
                    type: "",
                    categories: [],
                };
                fieldObj.type = category?.type?.toLowerCase();
                fieldObj.id = category?.id;
                fieldObj.name = category?.data?.name;
                //const type = "Choice";
                fieldObj.categories = category?.data?.categories?.data?.map(
                    (cat: any) => {
                        return {
                            type: "product",
                            name: cat?.name,
                            id: cat?.id,
                            category: category?.id,
                            categoryName: category?.data?.name
                        };
                    }
                );
                dataList?.push(fieldObj);
                return dataList;
            });

            return dataList
        };
        const dat = parseData()
        updateSidePanelData(dat)
    }, [modelData]);

    useEffect(() => {
        setSearchTerm("")
        updateFilteredData(sidePaneldata)
    }, [selectedObj])


    const [searchTerm, setSearchTerm] = useState<string>('')

    useEffect(() => {
        searchTerm ? updateFilteredData(searchByName(sidePaneldata)) : updateFilteredData(sidePaneldata)
    }, [searchTerm])

    useEffect(() => {
        searchByName(sidePaneldata)
    }, [searchChoice])

    useEffect(() => {
        setSearchChoice(false)
    }, [openPickPanel])


    function searchByName(data: Item[]): Item[] {
        const lowerCaseSearchTerm = searchTerm.toLowerCase();

        const filterByTerm = (text: string) => text?.toLowerCase().includes(lowerCaseSearchTerm);

        const filterChoices = (choices: Choice[]) =>
            choices?.filter(choice => filterByTerm(choice.name));

        const filterFields = (fields: Field[]) =>
            fields?.map(field => {
                if (searchChoice) {
                    const filteredChoices = filterChoices(field.choices as Choice[]);
                    return { ...field, choices: filteredChoices };
                }
                return field;
            }).filter(field => filterByTerm(field.name) || (searchChoice && (field?.choices as Choice[])?.length > 0));

        return data?.filter(item =>
            filterByTerm(item.name) ||
            item.fields?.some(field => filterByTerm(field.name) || field.choices?.some(choice => filterByTerm(choice.name))) ||
            item.categories?.some(category => filterByTerm(category.name))
        )?.map(item => ({
            ...item,
            fields: filterFields(item.fields as Field[]),
            categories: item.categories?.filter(category => filterByTerm(category.name))
        }));
    }



    return (
        <div className="tw-w-[261px] tw-border">
            {sidepanelType === "math" && <div className="tw-w-[260px]  tw-bg-gray-100 tw-border tw-border-zinc-00">
                <div className="tw-flex tw-justify-between">
                    <label>Math</label>
                    <button aria-label="Close" data-testid="rulecomponents-sidepanelcomponent-button-1" onClick={hidePickPanel}>
                        <XIcon />
                    </button>
                </div>
                <MathPanel />
            </div>}


            <div className="tw-flex tw-justify-between  tw-font-bold tw-m-2">
                <label>{sidepanelType === "math" ? "Add node to math expression" : "Add Node"}</label>
                {sidepanelType !== "math" && <button aria-label="Close" data-testid="rulecomponents-sidepanelcomponent-button-2" onClick={hidePickPanel}>
                    <XIcon />
                </button>}
            </div>

            <div className={`tw-flex tw-space-x-3`}>
                <div>
                    <div className={`tw-flex tw-item-center tw-rounded-md tw-bg-white tw-border tw-border-gray tw-w-[237px] tw-h-8 tw-px-2 tw-ml-2`}
                    >

                        <input data-testid="rulecomponents-sidepanelcomponent-input-3"
                            type="checkbox"
                            className="tw-w-4 tw-h-4 tw-bg-white tw-rounded tw-border tw-border-neutral-300 tw-mt-2 "
                            checked={searchChoice}
                            onChange={() => { setSearchChoice(prev => !prev) }}
                        />
                        <label className="tw-ml-1 tw-mt-[5px]">Search choices</label>

                    </div>
                    <div
                        className={`tw-flex tw-item-center tw-rounded-md tw-bg-white tw-border tw-border-gray tw-w-[237px] tw-h-8 tw-px-2 tw-ml-2`}
                    >
                        <button aria-label="Search" data-testid="rulecomponents-sidepanelcomponent-button-4"
                            className={`tw-relative tw-block tw-w-4 tw-aspect-square tw-h-full`}
                            type="button"
                        >
                            <SearchIcon />
                        </button>

                        <input data-testid="rulecomponents-sidepanelcomponent-input-5"
                            id="inputID"
                            type="search"
                            className={`focus:tw-outline-none
                                        
                                        tw-h-8      
                                        tw-border-0
                                        tw-text-xs 
                                        tw-block 
                                        tw-py-1 tw-px-3 
                                        tw-bg-transparent tw-bg-clip-padding
                                        tw-text-gray-700 focus:tw-text-gray-700  
                                        tw-rounded-md tw-flex-grow tw-font-normal 
                                        tw-shadow-none !autofill:tw-bg-gray autofill:tw-shadow-none`}
                            placeholder="Search"
                            aria-label="Search"
                            aria-describedby="basic-addon1"
                            autoComplete="off"
                            value={searchTerm}
                            // onKeyDown={handleKeyPress}
                            onChange={(e) => {
                                setSearchTerm(e.target.value)

                            }}
                        />
                    </div>

                    {/* <div className="tw-h-[600px] tw-overflow-scroll"> */}
                    <div className="tw-h-screen tw-overflow-scroll">
                        {(filteredData ? filteredData : sidePaneldata)?.map((item: TSidePanelData, index: number) => (
                            <SidePanelElement key={index} item={item} searchChoice={searchChoice} searchTerm={searchTerm} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SidePanelComponent;
